import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SubSink } from 'subsink';
import { FeatureManagerService, UserAdminService } from '@Services';

@Component({
    selector: 'app-user-activity',
    templateUrl: './user-activity.component.html',
    styleUrls: ['./user-activity.component.scss']
})
export class UserActivityComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild(MatSort) sort: MatSort;

    @Input() selectedUser: any;

    private readonly subs = new SubSink();
    searchText: string = '';
    data: any[] = [];
    dataSource: MatTableDataSource<any>;
    displayedColumns: string[] = ['eventType', 'description', 'date'];


    constructor(
        private readonly userAdminService: UserAdminService,
        private readonly featureManagerService: FeatureManagerService
    ) {
    }

    search() {
        const searchValue = this.searchText.trim().toLowerCase();

        this.dataSource.filterPredicate = (data, filter: string) => {
            const search = filter.toLowerCase();
            const eventType = (data.eventType || '').toLowerCase();
            const description = (data.description || '').toString().toLowerCase();

            return eventType.includes(search) || description.includes(search);
        };

        this.dataSource.filter = searchValue;
    }

    loadTableData() {
        this.dataSource = new MatTableDataSource(this.data.map(item => ({
            Id: item.id,
            eventType: item.eventType,
            description: item.description,
            date: new Date(item.lastModifiedDate)
        })));
        
        if (this.sort) {
            this.dataSource.sort = this.sort;
            this.sort.sort({
                id: 'date',
                start: 'desc',
                disableClear: true
            });
        }
    }

    ngOnInit() {
        this.userAdminService.getUserActivity(this.selectedUser?.id, true).subscribe((response) => {
            if (response) {
                this.data = response;
                this.loadTableData();
            }
        });
    }

    ngOnChanges() {
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}